import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 1.833C5.94 1.833 1.834 5.94 1.834 11S5.94 20.167 11 20.167c5.06 0 9.167-4.107 9.167-9.167S16.06 1.833 11 1.833Zm3.667 10.084h-2.75v2.75a.92.92 0 0 1-.917.916.92.92 0 0 1-.916-.916v-2.75h-2.75A.92.92 0 0 1 6.417 11a.92.92 0 0 1 .917-.917h2.75v-2.75A.92.92 0 0 1 11 6.417a.92.92 0 0 1 .917.916v2.75h2.75a.92.92 0 0 1 .917.917.92.92 0 0 1-.917.917Z",
    fill: "#fff"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h22v22H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };